<div class="table_holder">
  <div style="display: flex; justify-content: space-between; margin: 10px 0;">
    <h3>In-Progress Processes</h3>
    <button (click)="fetchTheProcess()" style="margin: 0 10px 10px 10px" mat-mini-fab color="accent">
      <mat-icon>replay</mat-icon>
    </button>
  </div>
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

    <!--- Note that these columns can be defined in any order.
      The actual rendered columns are set as a property on the row definition" -->
    <!-- Position Column -->
    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef> No. </th>
      <td mat-cell *matCellDef="let element"> {{element.position}} </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Process Client Name </th>
      <td mat-cell *matCellDef="let element"> {{element.clientName}} </td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="weight">
      <th mat-header-cell *matHeaderCellDef> Process Start </th>
      <td mat-cell *matCellDef="let element"> {{dateFormatter(element.startTime)}} {{formatAMPMT(element.startTime)}} </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="symbol">
      <th mat-header-cell *matHeaderCellDef> Output Type  </th>
      <td mat-cell *matCellDef="let element"> {{element.outputType}} </td>
    </ng-container>
    <ng-container matColumnDef="pstatus">
      <th mat-header-cell *matHeaderCellDef> Process Status  </th>
      <td mat-cell *matCellDef="let element"> {{element.status}} </td>
    </ng-container>
    <ng-container matColumnDef="loading">
      <mat-footer-cell *matFooterCellDef colspan="4">
        No process
      </mat-footer-cell>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of Process"></mat-paginator>



</div>
